import CarIcon from '@/graphics/icons/CarIcon.vue';
import CleaningIcon from '@/graphics/icons/CleaningIcon.vue';
import DriveIcon from '@/graphics/icons/DriveIcon.vue';
import ErrandsIcon from '@/graphics/icons/ErrandsIcon.vue';
import HomeworkIcon from '@/graphics/icons/HomeworkIcon.vue';
import LaundryIcon from '@/graphics/icons/LaundryIcon.vue';
import MealsIcon from '@/graphics/icons/MealsIcon.vue';
import PetsIcon from '@/graphics/icons/PetsIcon.vue';
import PottyIcon from '@/graphics/icons/PottyIcon.vue';
import SickIcon from '@/graphics/icons/SickIcon.vue';
import SpecialNeedsIcon from '@/graphics/icons/SpecialNeedsIcon.vue';
import TwinsIcon from '@/graphics/icons/TwinsIcon.vue';

interface SkillTypeToggleTokenDetail {
  type: string;
  text: string;
  icon: any;
}

const skillsToggleTokenOptions: SkillTypeToggleTokenDetail[] = [
  {
    type: 'accessToTransportation',
    text: 'Has a car',
    icon: CarIcon,
  },
  {
    type: 'lightHousekeeping',
    text: 'Housekeeping',
    icon: CleaningIcon,
  },
  {
    type: 'willingToDriveChildren',
    text: 'Can drive kids',
    icon: DriveIcon,
  },
  {
    type: 'willingToRunErrands',
    text: 'Can run errands',
    icon: ErrandsIcon,
  },
  {
    type: 'homeworkHelp',
    text: 'Homework help',
    icon: HomeworkIcon,
  },
  {
    type: 'laundry',
    text: 'Laundry',
    icon: LaundryIcon,
  },
  {
    type: 'mealPreparation',
    text: 'Meal prep',
    icon: MealsIcon,
  },
  {
    type: 'comfortableWithPets',
    text: 'Works with pets',
    icon: PetsIcon,
  },
  {
    type: 'pottyTraining',
    text: 'Toilet training',
    icon: PottyIcon,
  },
  {
    type: 'sickChildren',
    text: 'Sick care',
    icon: SickIcon,
  },
  {
    type: 'specialNeeds',
    text: 'Special needs care',
    icon: SpecialNeedsIcon,
  },
  {
    type: 'twins',
    text: 'Twins experience',
    icon: TwinsIcon,
  },
];

export { skillsToggleTokenOptions };
